<app-carousel [dataList]="favouriteGames" [identifier]="'favourites'"></app-carousel>
